/**
 * @flow
 */
'use strict';

export const diabetesTypeCodes = [
    {"code":"No Diabetes"},
    {"code":"Type 1"},
    {"code":"Type 2"},
    {"code":"Insulin dependent"},
    {"code":"Non-insulin dependent"}
]

export const diabetesControlCodes = [
    {"code":"Well controlled"},
    {"code":"Marginal control"},
    {"code":"Poor control"},
    {"code":"Uncontrolled"},
    {"code":"Newly diagnosed"}
]

export const diabetesSeverityCodes = [
    {"code":"Mild"},
    {"code":"Moderate"},
    {"code":"Severe"}
]


export const diabetesPresentationCodes = [
    {"code":"less than 6 months"},
    {"code":"6 - 12 months"},
    {"code":"12 - 18 months"},
    {"code":"18 - 24 months"},
    {"code":"2 years"},
    {"code":"3 years"},
    {"code":"4 years"},
    {"code":"5 years"},
    {"code":"5 - 7 years"},
    {"code":"7 - 10 years"},
    {"code":"10 - 15 years"},
    {"code":"15 - 20 years"},
    {"code":"20 - 25 years"},
    {"code":"Over 25 years"},
    {"code":"Since childhood"}
]

export const diabetesDurationCodes = [
    {"code":"Constant since diagnosis"},
    {"code":"Have had periods when glucose is not too high"}
]

export const diabetesTimingCodes = [
    {"code":"When weight is too high"},
    {"code":"Gestational"},
    {"code":"Associated with other illnesses"}
]

export const diabetesModifyingFactorCodes = [
    {"code":"Diet"},
    {"code":"Oral medications"},
    {"code":"Insulin"},
    {"code":"Insulin pump"},
    {"code":"Excercise"}
]
